import { lazy } from "react";

const RealTimeDynamic = lazy(() => import("../view/shipment/RealTimeDynamic"));
const ShipmentStatistic = lazy(() => import("../view/shipment/ShipmentStatistic"));
const shipment = [
  // 客订单统计
  {
    path: "/shipment/realTimeDynamic",
    component: RealTimeDynamic,
    id:"realTimeDynamic"
  },
  {
    path: "/shipment/shipmentStatistic",
    component: ShipmentStatistic,
    id:"shipmentStatistic"
  },
];
export default shipment;